import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Estadisticas } from 'src/app/interfaces/inicio';
import { InicioService } from 'src/app/services/inicio/inicio.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

    estadisticas: Estadisticas = {} as Estadisticas;

  constructor(private inicioService: InicioService, private title: Title, private meta: Meta) {
    this.agregarMetaData();
  }

  ngOnInit(): void {
      this.obtenerEstadisticas();
  }

  private agregarMetaData(): void {
    this.title.setTitle('Acerca de Nosotros');
    this.meta.updateTag({name: "description", content: "Tec Gurus empresa establecida durante más de 10 años, encuentra nuestra información sobre nosotros y como podemos ayudarte en la búsqueda de talento."});
    this.meta.updateTag({name: "keywords", content: "registro, empresas, postulaciones, vacantes, salario, nosotros, buscar empleo, empleos"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Acerca de Nosotros"});
    this.meta.updateTag({property: "og:description", content: "Tec Gurus empresa establecida durante más de 10 años, encuentra nuestra información sobre nosotros y como podemos ayudarte en la búsqueda de talento."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Acerca de Nosotros"});
    this.meta.updateTag({name: "twitter:description", content:"Tec Gurus empresa establecida durante más de 10 años, encuentra nuestra información sobre nosotros y como podemos ayudarte en la búsqueda de talento."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  async obtenerEstadisticas(){
    try {
        const response = await this.inicioService.obtenerEstadisticas();
        this.estadisticas = response.data;
    } catch (error) {
          console.error('erros al traer estadisticas', error)
    }
  }

}
